import { render, staticRenderFns } from "./MainHeader.vue?vue&type=template&id=1f889412&scoped=true"
import script from "./MainHeader.js?vue&type=script&lang=js&external"
export * from "./MainHeader.js?vue&type=script&lang=js&external"
import style0 from "./MainHeader.vue?vue&type=style&index=0&id=1f889412&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f889412",
  null
  
)

export default component.exports